import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Collapse } from 'react-bootstrap';
import classNames from 'classnames';
import { SubMenus } from './types';
import MenuItem from './MenuItem';


const removeSideNavLinkRef = (cls?: string) =>
    (cls || '')
        .split(' ')
        .filter(Boolean)
        .filter((c) => c !== 'side-nav-link-ref')
        .join(' ');

const MenuItemWithChildren = ({ item, linkClassName, subMenuClassNames, activeMenuItems, toggleMenu }: SubMenus) => {
    const [open, setOpen] = useState<boolean>(() => activeMenuItems?.includes(item.key) || false);
    const [badgeVisible, setBadgeVisible] = React.useState(false);

    useEffect(() => {
        const isActive = activeMenuItems?.includes(item.key) || false;
        if (open !== isActive) {
            setOpen(isActive);
        }
    }, [activeMenuItems, item.key, open]);

    const toggleMenuItem = (e: React.MouseEvent<HTMLAnchorElement | HTMLSpanElement, MouseEvent>) => {
        e.preventDefault();
        
        const status = !open;
        setOpen(status);
        if (toggleMenu) toggleMenu(item, status);
        return false;
    };

    // console.log('item', item);

    const content = (
        <>
            {item.icon && <i className={item.icon}></i>}
            {(item.badge && ((!(item.badge?.onlyHouver)) || badgeVisible)) && (
                <span
                    className={classNames('badge', 'bg-' + item.badge.variant, 'float-end', {
                        'text-dark': item.badge.variant === 'light',
                        'text-light': item.badge.variant === 'dark' || item.badge.variant === 'secondary',
                    })}
                >
                    {item.badge.text}
                </span>
            )}
            {((!(item.badge?.onlyHouver)) || !badgeVisible) && <span style={{ opacity: item.disable ? 0.6 : 1 }} className="menu-arrow"></span>}
            <span style={{ opacity: item.disable ? 0.6 : 1 }}> {item.label} </span>
        </>
    );

      const safeLinkClassName = removeSideNavLinkRef(linkClassName);

    const commonProps = {
        'data-menu-key': item.key,
        'aria-expanded': open,
        'data-ignore-active': 'true',
      className: classNames('has-arrow', 'side-sub-nav-link', safeLinkClassName, {
            'menuitem-active': !!activeMenuItems?.includes(item.key),
        }),
        style: { opacity: item.disable ? 0.6 : 1, cursor: 'pointer' } as React.CSSProperties, // <-- vírgula e tipagem ok
        onMouseEnter: () => {
            if (item.badge?.onlyHouver) setBadgeVisible(true);
        },
        onMouseLeave: () => setBadgeVisible(false),
    };

    return (
        <li className={classNames('side-nav-item', { 'menuitem-active': open })}>
            <Link
                to="#"
                onClick={toggleMenuItem}
                {...commonProps}
                style={item.disable ? { 
                    cursor: 'pointer', 
                } : {}}
            >
                {content}
            </Link>
            <Collapse in={open}>
                <ul className={classNames(subMenuClassNames)}>
                    {(item.children || []).map((child, index) => {
                        return (
                            <React.Fragment key={index.toString()}>
                                {child.children ? (
                                    <>
                                        {/* parent */}
                                        <MenuItemWithChildren
                                            item={child}
                                            linkClassName={activeMenuItems?.includes(child.key) ? 'active' : ''}
                                            activeMenuItems={activeMenuItems}
                                            subMenuClassNames="side-nav-third-level"
                                            toggleMenu={toggleMenu}
                                        />
                                    </>
                                ) : (
                                    <>
                                        {/* child */}
                                        <MenuItem
                                            item={child}
                                            className={activeMenuItems?.includes(child.key) ? 'menuitem-active' : ''}
                                            linkClassName={activeMenuItems?.includes(child.key) ? 'active' : ''}
                                        />
                                    </>
                                )}
                            </React.Fragment>
                        );
                    })}
                </ul>
            </Collapse>
        </li>
    );
};

export default MenuItemWithChildren;
